import { AppEnvironment } from "./environment.model";

export const environment: AppEnvironment = {
  production: false,
  bypassAuth: false,
  
  // apiUrl: 'https://pos-markaziatest.azurewebsites.net/POSAPI/api/',
  // apiUrl2: 'https://pos-markaziatest.azurewebsites.net/POSAPI/'

  masterBaseUrl: 'https://dxdevmaster.markaziaapis.com/api',
  serverName: 'https://dxdevmasterold.markaziaapis.com/api/',
  apiUrl: 'https://dxdevservicelayer.markaziaapis.com/api/',
  apiUrl2: 'https://dxdevmaster.markaziaapis.com/api/',
  portalPageUrl: 'https://dxdevportal.markaziahub.com/'
};
